import React, { useState } from 'react';
import { Alert, Button } from 'reactstrap';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Helmet from 'react-helmet';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Field, FormAlerts, useSession, ErrorBoundary } from '@cordata/buffet';

import { Splash } from '~/components';

import TermsOfUse from '~/components/TermsOfUse/form';

import MsLogin from '~/assets/ms-symbollockup_signin_light.svg';

const LoginForm = () => {
  const { state } = useLocation();
  const history = useHistory();
  const { login } = useSession();
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <ErrorBoundary>
      <Splash>
        <Helmet title="Login" />

        <Formik
          displayName="LoginForm"

          initialValues={{
            username: localStorage.getItem('remember-me') || '',
            password: '',
            rememberMe: !!localStorage.getItem('remember-me'),
          }}

          onSubmit={(values, { setErrors, setSubmitting }) =>
            login(values)
              .then((r) => {
                console.log(JSON.stringify(r));

                if (values.rememberMe) {
                  localStorage.setItem('remember-me', values.username);
                } else {
                  localStorage.removeItem('remember-me');
                }

                if (r.attributes.termsOfUseAcceptanceRequired) {
                  setTermsOpen(true);
                } else if (r.attributes.tfaRequired) {
                  localStorage.setItem('session', values.username);
                  history.push('/authorization');
                } else if (r.attributes.authDeviceRequired) {
                  history.push('/device-authentication', { ...values, ...r.attributes });
                } else {
                  window.location = r.attributes.passwordExpiresIn <= 7 || r.attributes.passwordResetRequired ? '/user/change-password' : '/home';
                }
              })
              .catch((e) => {
                const isLocked = typeof e === 'object' && e.response && e.response.status === 403;

                setErrors({ server: '', isLocked });
                setSubmitting(false);
              })
          }

          validationSchema={Yup.object().shape({
            username: Yup.string()
              .required(),
            password: Yup.string()
              .required(),
          })}
        >
          {({
            errors,
            isSubmitting,
            submitCount,
          }) => (
            <Form noValidate>
              { state && state.deviceAuthStatus && <Alert color={state.deviceAuthStatus.result === 'error' ? 'danger' : 'success'}>{ state.deviceAuthStatus.message }</Alert> }
              { submitCount >= 1 && errors && <FormAlerts errors={errors} loginMessage={errors.isLocked ? 'Due to too many incorrect attempts, this account has been locked. Please contact your administrator.' : undefined} login /> }

              <Field
                name="username"
                label={false}
                placeholder="Enter your email / username"
                size="lg"
              />

              <Field
                name="password"
                type="password"
                label={false}
                size="lg"
              />

              <Field
                name="rememberMe"
                type="checkbox"
                label={false}
                placeholder="Remember me?"
                className="bg-transparent border-0 text-white"
              />

              <Button type="submit" disabled={isSubmitting} block color="secondary">
                {isSubmitting ? 'Logging in ...' : 'Login'}
              </Button>

              <p className="text-right text-light mt-3 mb-0">
                <Link to="/forgot-password" className="text-light">Forgot Password?</Link>
              </p>

              <Link className="btn btn-block" to="/auth-response">
                <img src={MsLogin} className="mt-3 mb-0" alt="Login With Microsoft" />
              </Link>
            </Form>
          )}
        </Formik>

        {termsOpen && <TermsOfUse layout="modal" title="Terms of Use" isOpen={termsOpen} background="static" size="xl" onClosed={() => setTermsOpen(false)} />}
      </Splash>
    </ErrorBoundary>
  );
};

export default LoginForm;
